module.exports = __webpack_public_path__ + "static/media/fresh-juice.6e28fdca.svg";